/** SPAIN FORM **/

require('jqmask');

/* POSTCODES (ZIP) in Spain have 5 digits.
 The first 2 digits (ranging 01–52) of the postal code correspond to one of the fifty provinces of Spain,
 plus the two autonomous cities on the African coast.
 */
$.validator.addMethod(
    'zipValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }

/*
 Here we check there is only 5 numbers.
 Also some provinces and autonomous cities are not accepted :
 - 35 : Las Palmas (Canary Islands)
 - 38 : Santa Cruz de Tenerife (Canary Islands)
 - 51 : Ceuta
 - 52 : Melilla
 */
      return !(/^(35|38|51|52)[0-9]{3}$/).test(value);
    }
);

/*
  NATIONAL MOBILE NUMBER in Spain have 9 digits.
 */
$.validator.addMethod(
    'mobileValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }
/*
 Here we check there is only 9 numbers.
 Also we accept only 6 or 7 as the first digit
 */
      return (/^(6|7)[0-9]{8}$/).test(value);
    }
);

$(() => {
  // MOBILE NUMBER - Mask of 9 digits
  $("[data-id='mobile']").mask('999999999', { placeholder: '' });
  // POSTAL CODE - Mask of 5 digits
  $("[data-id='zip']").mask('99999', { placeholder: '' });
});



// WEBPACK FOOTER //
// ./js/countryForm/spain.form.js